import { Type, Wand2 } from 'lucide-react'
import { useLocation } from 'react-router-dom'
import { PageDescription, RoutingTabs } from '@/components/ui'

const imageTabs = [
  {
    id: 't2i',
    label: 'Text to Image',
    icon: Type,
    path: '/images/t2i',
    description:
      'Generate a fresh image from a text prompt. Anything you can describe.',
  },
  {
    id: 'image-edit',
    label: 'Image Editing',
    icon: Wand2,
    path: '/images/image-edit',
    description:
      'Refine an existing image. Change clothing, swap backgrounds, tweak details.',
  },
]

export function ImageTabs() {
  const location = useLocation()
  const active = imageTabs.find((tab) => location.pathname === tab.path)
  return (
    <>
      <RoutingTabs items={imageTabs} />
      {active?.description && (
        <PageDescription className="mt-3">{active.description}</PageDescription>
      )}
    </>
  )
}
